import React from 'react';
import './WhySection.css';
import { FaShieldAlt, FaMoneyBillWave, FaStar, FaTools, FaClock } from 'react-icons/fa';
import { GiTakeMyMoney } from "react-icons/gi";

const WhySection: React.FC = () => (
  <div className="why-choose-us-container">
    <h2 className="why-choose-us-title">Why Yenro Auto Car Detailing</h2>

    <div className="why-choose-us">
      <div className="point">
        <FaShieldAlt size={40} color="gold" />
        <h3>Reliable & Insured Service</h3>
        <p>Your vehicle is in safe hands with our insured professionals.</p>
      </div>

      <div className="point">
        <FaMoneyBillWave size={40} color="gold" />
        <h3>Affordable & Transparent Pricing</h3>
        <p>No hidden costs. We offer great value for your money.</p>
      </div>

      <div className="point">
        <FaStar size={40} color="gold" />
        <h3>100% Satisfaction Guarantee</h3>
        <p>If you’re not satisfied, we offer a money-back guarantee.</p>
      </div>

      <div className="point">
        <FaTools size={40} color="gold" />
        <h3>Expert Detailing</h3>
        <p>We use premium products to restore your car’s beauty.</p>
      </div>
      <div className="point">
        <FaClock size={40} color="gold" />
        <h3>We Save Your Time</h3>
        <p>No need to wait in queues. We come to you for a hassle-free experience.</p>
      </div>
      <div className="point">
        <GiTakeMyMoney size={40} color="gold" />
        <h3>Special Offers</h3>
        <p>Get a free Detail with every two services!</p>
      </div>
    </div>
  </div>
);

export default WhySection;
